import { useState } from 'react';

export const useChildrenRef = <Ref>(): [Ref | undefined, (ref: Ref) => void] => {
  const [ref, setRef] = useState<Ref>();

  const setRefFunction = (e: Ref) => !!e && !ref && setRef(e);

  return [ref, setRefFunction];
};
